import React from 'react';
import { Flex, Typography } from '@banhala/ui-kit';

export const PocInformation = () => {
  return (
    <Flex.Column
      backgroundColor="bg_secondary"
      padding={{ vertical: 16, horizontal: 16 }}
    >
      <Typography type="subtitle1" color="content_primary" marginBottom={16}>
        참고해주세요
      </Typography>
      <Typography type="body2" color="content_tertiary" marginBottom={16}>
        • 등록된 상담 그룹이 아니라면 개인정보 보호법으로 인해 상담이 어려워요.
      </Typography>
      <Typography type="body2" color="content_tertiary" marginBottom={16}>
        • 상담 그룹은 에이블리 계정을 가진 본인이 직접 등록할 수 있어요.
      </Typography>
      <Typography type="body2" color="content_tertiary" marginBottom={16}>
        • 상담 그룹을 등록하기 위해서는 본인 인증과 제3자 정보 제공 동의가
        필요해요.
      </Typography>
      <Typography type="body2" color="content_tertiary">
        • 상담 그룹은 최대 두 명까지 저장할 수 있어요.
      </Typography>
    </Flex.Column>
  );
};
